import { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { isPageItemSelected } from '@cbridge-utils/navigation';
import { NavigationListItemButton } from '@cbridge-tools/navigation-item';
import { useSettingsNavigationItems, RouteSegments } from '@cbridge-packages/routing-client-admin';
import { ISidebarFooterProps } from '@cbridge-modules/sidebar';
import { SETTINGS_PATHNAME } from './ConfigSidebarFooter.constant';

export const SettingsItem: FunctionComponent<ISidebarFooterProps> = (props) => {
  const { mini, toggleAction } = props;

  const { pathname } = useLocation();

  const { t } = useTranslation();

  const settingsNavigation = useSettingsNavigationItems();

  const pattern = settingsNavigation
    .reduce((acc, item) => {
      if (item.kind !== 'page') {
        return acc;
      }

      if (item.pattern) {
        if (Array.isArray(item.pattern)) {
          acc.push(...item.pattern);
        } else {
          acc.push(item.pattern);
        }
      } else {
        acc.push(`${item.segment}{/*path}`);
      }
      return acc;
    }, [] as string[]);

  const isSelected = isPageItemSelected({ pattern }, `/${RouteSegments.Root.Config}`, pathname);

  return (
    <ListItem
      sx={{
        py: 0,
        px: 0,
        overflowX: 'hidden',
      }}
      secondaryAction={!mini && toggleAction}
    >
      <NavigationListItemButton
        isActionAlwaysVisible={true}
        selected={isSelected}
        component={Link}
        to={`/${SETTINGS_PATHNAME}`}
      >
        <ListItemIcon sx={{
          minWidth: 40,
        }}
        >
          <SettingsApplicationsIcon />
        </ListItemIcon>
        {!mini && (
          <ListItemText
            primary={t('text:navigation.config.settings.title')}
            sx={{
              '& .MuiTypography-root': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            }}
          />
        )}
      </NavigationListItemButton>
    </ListItem>
  );
};
